import loadable from '@loadable/component';

export const ReportsDetailGraphicConfigurationFilterTagIntelligent = loadable(
  () => import('./ReportsDetailGraphicConfigurationFilterTagIntelligent'),
);
